{
  "version": 1,
  "asset_id": "53e9135c-234c-4181-ad3e-6fb6b6f19e2c",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/53e9135c-234c-4181-ad3e-6fb6b6f19e2c/evenementen-zaal-congres.jpg",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/53e9135c-234c-4181-ad3e-6fb6b6f19e2c/evenementen-zaal-congres.jpg",
  "original_filename": "evenementen-zaal-congres.jpg",
  "size": 1919840,
  "content_type": "image/jpeg",
  "created_at": "2026-09-01T10:05:25Z"
}
